"use client";

import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  // SSR placeholder - same dimensions as actual buttons to prevent layout shift
  if (!mounted) {
    return (
      <div className="border-border bg-background flex w-fit items-center gap-0.5 rounded-full border p-0.5">
        <div className="text-muted-foreground rounded-full p-1.5">
          <Monitor className="h-3.5 w-3.5" />
        </div>
        <div className="bg-muted text-foreground rounded-full p-1.5">
          <Sun className="h-3.5 w-3.5" />
        </div>
        <div className="text-muted-foreground rounded-full p-1.5">
          <Moon className="h-3.5 w-3.5" />
        </div>
      </div>
    );
  }

  return (
    <div className="border-border bg-background flex w-fit items-center gap-0.5 rounded-full border p-0.5">
      <button
        onClick={() => {
          setTheme("system");
        }}
        className={`rounded-full p-1.5 transition-colors ${
          theme === "system"
            ? "bg-muted text-foreground"
            : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
        }`}
        aria-label="System theme"
        title="System theme"
      >
        <Monitor className="h-3.5 w-3.5" />
      </button>
      <button
        onClick={() => {
          setTheme("light");
        }}
        className={`rounded-full p-1.5 transition-colors ${
          theme === "light"
            ? "bg-muted text-foreground"
            : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
        }`}
        aria-label="Light theme"
        title="Light theme"
      >
        <Sun className="h-3.5 w-3.5" />
      </button>
      <button
        onClick={() => {
          setTheme("dark");
        }}
        className={`rounded-full p-1.5 transition-colors ${
          theme === "dark"
            ? "bg-muted text-foreground"
            : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
        }`}
        aria-label="Dark theme"
        title="Dark theme"
      >
        <Moon className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
